import React from "react";
import "./Home.css";
import Product from "./Product";
import { productInfo } from "../../contents/productInfo";

function Home() {
  const rowOne = productInfo.slice(0, 2);
  const rowTwo = productInfo.slice(2, 5);
  const rowThree = productInfo.slice(5);

  return (
    <div className="home">
      <div className="home__container">
        <img
          src="https://m.media-amazon.com/images/I/51AQhraI0-L._SX3000_.png"
          alt="banner"
          className="home__image"
        />
        <div className="home__row">
          {rowOne.map(({ id, title, price, image, rating }) => (
            <Product
              id={id}
              title={title}
              price={price}
              image={image}
              rating={rating}
            />
          ))}
        </div>
        <div className="home__row">
          {rowTwo.map(({ id, title, price, image, rating }) => (
            <Product
              id={id}
              title={title}
              price={price}
              image={image}
              rating={rating}
            />
          ))}
        </div>
        <div className="home__row">
          {rowThree.map(({ id, title, price, image, rating }) => (
            <Product
              id={id}
              title={title}
              price={price}
              image={image}
              rating={rating}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
